import { theme } from "@xola/ui-kit";
import React, { ComponentProps } from "react";
import { FormatInput } from "./FormatInput";

export const PercentInput = (props: ComponentProps<typeof FormatInput>) => {
    const prefixColors = {
        background: theme.colors.gray.lighter,
        border: theme.colors.secondary.light,
    };
    const style = props.isStyled
        ? { boxShadow: `inset ${prefixColors.background} 40px 0 0 -1ex, inset ${prefixColors.border} 41px 0 0 -1ex` }
        : {};

    const prefix = props.isStyled ? `%     ` : `%  `;

    return <FormatInput style={style} prefix={prefix} {...props} />;
};
